'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";

export class ContinousReportsAttachmentsCtrl extends EvaluationBaseCtrl
{

    postConstruct(){
        let report = this.jsDataService.get('item', {});
        if(typeof(report.attachments) === 'object'){
            this.attachments = report.attachments;
        }
        this.cfg.uploadUrl = this.jsDataService.get('cfgUploadUrl');
        this.cfg.saveUrl = this.jsDataService.get('cfgSaveUrl');
        this.cfg.removeUrl = this.jsDataService.get('cfgRemoveUrl');
    }

    attachmentName(attachment){
        return 'name_'+attachment.number;
    }

    saveAttachment(attachment){
        let data = {
            file_id: attachment.file.file_id,
            title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, '')
        };
        if(this.cfg.saveUrl && this.cfg.saveUrl !== ''){
            this.$scope.basicHttpConfigProcess({
                url: this.cfg.saveUrl,
                method: 'POST',
                data: data
            }).then((response) => {
                if(response.data.success && typeof(response.data.items) !== 'undefined'){
                    this.attachments = response.data.items;
                    this.attfile.file = {};
                }
            }, () => {});
        }
        else{
            console.log('no url ', this.cfg.saveUrl);
        }
    }

    removeAttachment(ev, attachment){
        if(this.cfg.removeUrl !== ''){
            const confirmTexts = this.jsDataService.get('attachmentRemoveConfirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.cfg.removeUrl,
                    method: 'GET',
                    responseType: 'json',
                    params: {
                        id: attachment.id
                    }
                }).then((response) => {
                    if(response.data.success && typeof(response.data.items) !== 'undefined'){
                        this.attachments = response.data.items;
                    }
                });
            }, () => {});
        }
    }

    fileAdded($file) {
        const ext = $file.getExtension().toLowerCase();

        if (!this.cfg.fileFilter[ext]) {
            this.notify(this.$filter('tr')('file_pdf_allowed'), true);
            return false;
        }

        if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
            this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
            return false;
        }

        if(!this.activeUpload()){
            return false;
        }

        this.addFlowFile($file);
        return true;
    }

    autosavePostFields(){
        return {
            attachments: this.attachments
        };
    }
}